import { useMemo } from 'react';
import { FORM_FIELDS_SAVED_VALUES } from '../constants/formFields.constants';
import { localStorageService } from '../utils/window.utils.js'


const useGetLocalStorageValues = (localStorageFieldKey: string) => {
    const sessionStorageValue = useMemo(() => {
        const formValues = JSON.parse(localStorageService().getItem(FORM_FIELDS_SAVED_VALUES) || '{}');
        return formValues?.[localStorageFieldKey] || '';
    }, [localStorageFieldKey]);

    return sessionStorageValue;
}

export default useGetLocalStorageValues;
